const PREFERRED = {
  'accent chair': 'Accent Chairs',
  'accent chair at sofa': 'Accent Chairs',
  'accent table': 'Accent Tables',
  'artwork': 'Artwork',
  'banquette': 'Banquettes',
  'bar': 'Bars',
  'bar cart': 'Bar Carts',
  'bars and bar back': 'Bars',
  'bar stool': 'Bar Stools',
  'bench': 'Benches',
  'bistro table': 'Bistro Tables',
  'buffet display': 'Buffet Displays',
  'chair': 'Chairs',
  'chaise': 'Chaises',
  'cocktail table': 'Cocktail Tables',
  'coffee table': 'Coffee Tables',
  'column': 'Columns',
  'console': 'Consoles',
  'console table': 'Consoles',
  'counter stool': 'Counter Stools',
  'custom': 'Custom Build',
  'custom build': 'Custom Build',
  'desk': 'Desks',
  'detail': 'Details',
  'dining chair': 'Dining Chairs',
  'dining table': 'Dining Tables',
  'end table': 'End Tables',
  'floor lamp': 'Floor Lamps',
  'floor mirror': 'Mirrors',
  'folding table': 'Folding Tables',
  'lamp': 'Lamps',
  'lounge chair': 'Lounge Chairs',
  'media console': 'Consoles',
  'mirror': 'Mirrors',
  'misc': 'Misc',
  'ottoman': 'Ottomans',
  'outdoor': 'Outdoor',
  'pedestal': 'Pedestals',
  'pendant': 'Pendants',
  'pillow': 'Pillows',
  'plant': 'Plants',
  'pouf': 'Poufs',
  'pub table': 'Pub Tables',
  'room divider': 'Room Dividers',
  'rug': 'Rugs',
  'sectional': 'Sectionals',
  'sectional sofa': 'Sectionals',
  'settee': 'Settees',
  'shelf': 'Shelving',
  'shelving': 'Shelving',
  'side table': 'Side Tables',
  'sofa': 'Sofas',
  'sofa table': 'Sofa Tables',
  'specialty table': 'Specialty Tables',
  'stage front': 'Stage Fronts',
  'stool': 'Stools',
  'stool ottoman': 'Ottomans',
  'table': 'Tables',
  'table lamp': 'Table Lamps',
  'umbrella': 'Umbrellas',
  'upholstery': 'Upholstery',
  'wall': 'Walls'
};

function singularizeWord(word) {
  if (!word || word.length <= 3) return word;
  if (word === 'and' || word === '&') return word;
  if (word.endsWith('ies') && word.length > 4) return `${word.slice(0, -3)}y`;
  if (/(sses|xes|zes|ches|shes)$/.test(word)) return word.slice(0, -2);
  if (word.endsWith('s') && !word.endsWith('ss') && !word.endsWith('us')) return word.slice(0, -1);
  return word;
}

function titleCase(value) {
  return String(value || '')
    .split(' ')
    .map((word) => {
      if (word === '&') return '&';
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export function normalizeCategoryRaw(raw) {
  return String(raw || '')
    .toLowerCase()
    .replace(/[_/]+/g, ' ')
    .replace(/['’]/g, '')
    .replace(/[.]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/coffeee+/g, 'coffee')
    .replace(/\bmirros?\b/g, 'mirror')
    .replace(/\bpilows?\b/g, 'pillow')
    .replace(/bar\s*stools?/g, 'bar stool')
    .replace(/^bars?\s*&\s*bar backs?$/, 'bars')
    .replace(/^bars?\s+and\s+bar backs?$/, 'bars')
    .replace(/^sofa\s+\d.*$/, 'sofa');
}

export function catalogCategoryKey(raw) {
  const normalized = normalizeCategoryRaw(raw);
  if (!normalized) return '';
  if (PREFERRED[normalized]) return PREFERRED[normalized];
  const singular = normalized.split(' ').map(singularizeWord).join(' ');
  if (PREFERRED[singular]) return PREFERRED[singular];
  return titleCase(singular);
}

export function displayCatalogCategory(raw) {
  return catalogCategoryKey(raw);
}

export function uniqueCatalogCategories(products = []) {
  const labels = new Set();
  products.forEach((product) => {
    const label = catalogCategoryKey(product?.category);
    if (label) labels.add(label);
  });
  return [...labels].sort((a, b) => a.localeCompare(b));
}
